import React, { useContext } from "react";
import clsx from "clsx";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PageContext from "@PageContext";
import useSystemLinks from "@micado-digital/react-ui/hooks/useSystemLinks";
import groupFollowingElementsByTag from "@micado-digital/react-ui/utils/groupFollowingElementsByTag";
import groupExactlyElements from "@micado-digital/react-ui/utils/groupExactlyElements";
import getJSXElement from "./getJSXElement";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import localDE from "@localDE";
import localEN from "@localEN";

import styles from "./Elements.styles";

const Elements = () => {
	const css = styles();
	const [pageData] = useContext(PageContext);
	let { elements, lang = "de" } = pageData;
	const sysLink = useSystemLinks();
	const screenMD = useMediaQuery(theme => theme.breakpoints.up("md"));
	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	// group downloads

	elements = groupFollowingElementsByTag(elements, "basic-download-group", "basic-download");

	if (elements?.filter(item => item?.tag === "basic-list" && item?.variant === 1)) {
		elements = groupExactlyElements(elements, "extension-image-list-combo", [
			"basic-singleimage",
			"basic-list"
		]);
	}

	// group dropdowns

	elements = groupFollowingElementsByTag(
		elements,
		"basic-dropdown-group",
		["basic-dropdown", "*"],
		"basic-dropdown",
		"basic-dropdown"
	);

	return (
		<div className={clsx(css.elements, "mco-elements")} id="main-content">
			{elements?.map(element => {
				return getJSXElement(element, lang, sysLink, screenMD, l);
			})}
		</div>
	);
};

export default Elements;
